var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99935 8.00033C1.99935 4.70185 4.70087 2.00033 7.99935 2.00033C8.83748 2.00033 9.67537 2.17992 10.4533 2.53896C10.7876 2.69326 11.1837 2.54733 11.338 2.21303C11.4923 1.87873 11.3464 1.48265 11.0121 1.32835C10.0567 0.8874 9.02788 0.666992 7.99935 0.666992C3.96449 0.666992 0.666016 3.96547 0.666016 8.00033C0.666016 12.0352 3.96449 15.3337 7.99935 15.3337C12.0342 15.3337 15.3327 12.0352 15.3327 8.00033V7.40033C15.3327 7.03214 15.0342 6.73366 14.666 6.73366C14.2978 6.73366 13.9993 7.03214 13.9993 7.40033V8.00033C13.9993 11.2988 11.2978 14.0003 7.99935 14.0003C4.70087 14.0003 1.99935 11.2988 1.99935 8.00033Z",
    fill: "#787A84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1374 3.1384C15.3978 2.87805 15.3978 2.45594 15.1374 2.19559C14.8771 1.93524 14.455 1.93524 14.1946 2.19559L7.99935 8.39085L6.47075 6.86225C6.2104 6.6019 5.78829 6.6019 5.52794 6.86225C5.26759 7.1226 5.26759 7.54471 5.52794 7.80506L7.52794 9.80506C7.78829 10.0654 8.2104 10.0654 8.47075 9.80506L15.1374 3.1384Z",
    fill: "#787A84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.cce54dbd.svg";
export { ForwardRef as ReactComponent };